import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scoped.css';
import { Link } from 'react-router-dom';
import ButtonAction from '../Button/Button';

export default function Button({
  children = null,
  className = '',
  disabled = false,
  outlined = false,
  to = '/',
  type = '',
}) {
  const classes = [
    styles.root,
    ...(outlined ? [styles.outlined] : []),
    className,
    type === 'primary' ? styles.primary : '',
  ]
    .filter(Boolean)
    .join(' ');

  return disabled ? (
    <ButtonAction className={classes} disabled>
      {children}
    </ButtonAction>
  ) : (
    <Link className={classes} to={to}>
      {children}
    </Link>
  );
}

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  outlined: PropTypes.bool,
  to: PropTypes.string,
  type: PropTypes.string,
};
